"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const PageCounter_module_css_1 = __importDefault(require("./styles/PageCounter.module.css"));
const PageCounter = ({ from, to }) => {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: PageCounter_module_css_1.default.text }, { children: [i18n_1.default.t("Showing"), " ", (0, jsx_runtime_1.jsx)("span", Object.assign({ className: PageCounter_module_css_1.default.number }, { children: from })), " ", i18n_1.default.t("from"), " ", (0, jsx_runtime_1.jsx)("span", Object.assign({ className: PageCounter_module_css_1.default.number }, { children: to }))] })));
};
exports.default = PageCounter;
